<template>
  <v-window-item value="general">
    <v-card-text>
      <v-card class="bg-white" variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-briefcase</v-icon>
          General Information
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="phone_office.value.value"
                  label="Office Phone"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="phone_office.errorMessage.value"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="phone_residence.value.value"
                  label="Residence Phone"
                  variant="outlined"
                  bg-color="grey-lighten-4"
                  density="compact"
                  :error-messages="phone_residence.errorMessage.value"
                  clearable
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-card variant="outlined">
                  <v-card-title class="text-subtitle-1">
                    <v-icon class="me-1" size="small">mdi-bank</v-icon>
                    Bank Information
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6" class="pr-0">
                        <v-autocomplete
                            v-model="bank_id.value.value"
                            label="Bank"
                            :items="getBankList"
                            item-title="name"
                            item-value="id"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="bank_id.errorMessage.value"
                            clearable
                        
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                            v-model="account_number.value.value"
                            label="Account Number"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="account_number.errorMessage.value"
                            clearable
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6">
                <v-card variant="outlined" class="h-100">
                  <v-card-title class="text-subtitle-1">
                    <v-icon class="me-1" size="small">mdi-file-certificate</v-icon>
                    Tax Information
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6" class="pr-0">
                        <v-text-field
                            v-model="tin_number.value.value"
                            label="TIN Number"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="tin_number.errorMessage.value"
                            clearable
                        />
                        <v-autocomplete
                            v-model="tax_circle.value.value"
                            label="Tax Circle"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :items="getTaxCircle"
                            :error-messages="tax_circle.errorMessage.value"
                            item-title="text"
                            item-value="value"
                            clearable
                        
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      </v-col>
                      <v-col cols="6">
                        <v-autocomplete
                          v-model="tax_zone.value.value"
                          label="Tax Zone"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :items="getTaxZone"
                          :error-messages="tax_zone.errorMessage.value"
                          item-title="text"
                          item-value="value"
                          clearable
                        
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-card variant="outlined" class="h-100">
                  <v-card-title class="text-subtitle-1">
                    <v-icon class="me-1" size="small">mdi-car</v-icon>
                    Driving Information
                  </v-card-title>
                  <v-card-text>

                    <v-row>
                      <v-col cols="6" class="pr-0">
                        <v-text-field
                            v-model="license_number.value.value"
                            label="License Number"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="license_number.errorMessage.value"
                            clearable
                        />
                        <v-date-input
                            v-model="renewal_from.value.value"
                            input-format="dd/mm/yyyy"
                            label="Renewal From"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="renewal_from.errorMessage.value"
                            clearable
                        />
                      </v-col>
                      <v-col cols="6">
                        <v-date-input
                            v-model="renewal_to.value.value"
                            input-format="dd/mm/yyyy"
                            label="Renewal To"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="renewal_to.errorMessage.value"
                            clearable
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="12" md="6">
                <v-card variant="outlined" class="h-100">
                  <v-card-title class="text-subtitle-1">
                    <v-icon class="me-1" size="small">mdi-list-status</v-icon>
                    Employment Status
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6" class="pr-0">
                        <v-autocomplete
                            v-model="payment.value.value"
                            label="Payment"
                            :items="paymentList"
                            item-title="label"
                            item-value="value"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="payment.errorMessage.value"
                            clearable
                        
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                        <v-autocomplete
                            v-model="reason_id.value.value"
                            label="Reason"
                            :items="getPaymentReasonList"
                            item-title="reason"
                            item-value="id"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="reason_id.errorMessage.value"
                            clearable
                        
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                      </v-col>
                      <v-col cols="6">
                        <v-date-input
                            v-model="leaving_date.value.value"
                            input-format="dd/mm/yyyy"
                            label="Leaving Date"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="leaving_date.errorMessage.value"
                            clearable
                        />
                        <v-text-field
                            v-model="note.value.value"
                            label="Leaving Notes"
                            variant="outlined"
                            density="compact"
                            bg-color="grey-lighten-4"
                            :error-messages="note.errorMessage.value"
                            clearable
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-card-actions class="px-0">
              <v-spacer />
              <v-btn color="primary" type="submit" variant="flat" :loading="submitting">
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script>
import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';

export default {
  props: {
    userGeneralInfoData: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    submitting: false,
    paymentList: [
      { label: 'Paid', value: 1 },
      { label: 'Unpaid', value: 2 }
    ]
  }),
  computed: {
    getTaxCircle() {
      return [
        { text: 'Dhaka Circle-1', value: 'dhaka_1' },
        { text: 'Dhaka Circle-2', value: 'dhaka_2' },
        { text: 'Chittagong Circle', value: 'chittagong' },
        { text: 'Sylhet Circle', value: 'sylhet' },
        { text: 'Rajshahi Circle', value: 'rajshahi' }
      ]
    },
    getTaxZone() {
      return [
        { text: 'Zone-1', value: 'zone_1' },
        { text: 'Zone-2', value: 'zone_2' },
        { text: 'Zone-3', value: 'zone_3' },
        { text: 'Zone-4', value: 'zone_4' }
      ]
    },
    getBankList() {
      return this.$store.getters.getHrmEmployeeBankSetupList || [];
    },
    getPaymentReasonList() {
      return this.$store.getters.getHrmPaymentReasonList || [];
    }
  },
  created() {
    // if (this.getBankList.length === 0) {
      this.$store.dispatch('getHrmEmployeeBankSetupList');
    // }
    // if (this.getPaymentReasonList.length === 0) {
      this.$store.dispatch('getHrmPaymentReasonList');
    // }
  },
  watch: {
    userGeneralInfoData: {
      handler(data) {
        const employee = data?.employee || {};
        const generalInfo = data?.general_info || {};
        const bankInfo = data?.bank_info || {};
        const taxInfo = data?.tax_info || {};
        const drivingInfo = data?.driving_info || {};
        const employmentStatus = data?.employment_status || {};

        this.employee_id.value.value = employee.id;
        this.branch_id.value.value = employee.branch_id;
        this.code.value.value = employee.code || '';
        this.employee_type_id.value.value = employee.employee_type_id || '';
        this.department_id.value.value = employee.department_id || '';
        this.designation_id.value.value = employee.designation_id || '';
        this.section_id.value.value = employee.section_id || '';
        this.status.value.value = employee.status ?? 1;
        this.phone_office.value.value = employee.phone_office || '';
        this.phone_residence.value.value = employee.phone_residence || '';
        this.joining_date.value.value = employee.joining_date;
        this.hod_approve_employee_id.value.value = employee.hod_approve_employee_id || null;
        this.hr_approve_employee_id.value.value = employee.hr_approve_employee_id || null;

        this.employee_category.value.value = generalInfo.employee_category || '';
        this.office_location.value.value = generalInfo.office_location || '';
        this.appointment_date.value.value = generalInfo.appointment_date || '';
        this.confirmation_date.value.value = generalInfo.confirmation_date || '';
        this.late_count.value.value = generalInfo.late_count || '';

        this.bank_id.value.value = bankInfo.bank?.id || null;
        this.account_number.value.value = bankInfo.account_number || '';
        this.tin_number.value.value = taxInfo.tin_number || '';
        this.tax_circle.value.value = taxInfo.tax_circle || '';
        this.tax_zone.value.value = taxInfo.tax_zone || null;
        this.license_number.value.value = drivingInfo.license_number || '';
        this.renewal_from.value.value = drivingInfo.renewal_from || '';
        this.renewal_to.value.value = drivingInfo.renewal_to || '';
        this.payment.value.value = employmentStatus.payment || '';
        this.reason_id.value.value = employmentStatus.reason_id || null;
        this.leaving_date.value.value = employmentStatus.leaving_date || null;
        this.note.value.value = employmentStatus.note || '';
      },
      immediate: true,
      deep: true
    }
  },
  setup() {
    const store = useStore();
    const { handleSubmit } = useForm({ validationSchema: yup.object({}) });
    const branch_id = useField('branch_id');
    const employee_id = useField('employee_id');
    const code = useField('code');
    const employee_type_id = useField('employee_type_id');
    const department_id = useField('department_id');
    const designation_id = useField('designation_id');
    const section_id = useField('section_id');
    const status = useField('status');
    const phone_office = useField('phone_office');
    const phone_residence = useField('phone_residence');
    const joining_date = useField('joining_date');
    const hod_approve_employee_id = useField('hod_approve_employee_id');
    const hr_approve_employee_id = useField('hr_approve_employee_id');
    const employee_category = useField('employee_category');
    const office_location = useField('office_location');
    const appointment_date = useField('appointment_date');
    const confirmation_date = useField('confirmation_date');
    const late_count = useField('late_count');
    const bank_id = useField('bank_id');
    const account_number = useField('account_number');
    const tin_number = useField('tin_number');
    const tax_circle = useField('tax_circle');
    const tax_zone = useField('tax_zone');
    const license_number = useField('license_number');
    const renewal_from = useField('renewal_from');
    const renewal_to = useField('renewal_to');
    const payment = useField('payment');
    const reason_id = useField('reason_id');
    const leaving_date = useField('leaving_date');
    const note = useField('note');
    const submitting = ref(false);

    const submit = handleSubmit((values) => {
      submitting.value = true;
      const generalInfoData = {
        employee_id: employee_id.value.value,
        employee: {
          code: code.value.value,
          employee_type_id: employee_type_id.value.value,
          department_id: department_id.value.value,
          designation_id: designation_id.value.value,
          section_id: section_id.value.value || null,
          status: status.value.value,
          phone_office: phone_office.value.value,
          phone_residence: phone_residence.value.value,
          joining_date: joining_date.value.value,
          hod_approve_employee_id: hod_approve_employee_id.value.value,
          hr_approve_employee_id: hr_approve_employee_id.value.value
        },
        general_info: {
          employee_category: employee_category.value.value,
          office_location: office_location.value.value,
          appointment_date: appointment_date.value.value,
          confirmation_date: confirmation_date.value.value,
          joining_date: joining_date.value.value,
          late_count: late_count.value.value
        },
        bank_info: {
          bank_id: bank_id.value.value,
          account_number: account_number.value.value
        },
        tax_info: {
          tin_number: tin_number.value.value,
          tax_circle: tax_circle.value.value,
          tax_zone: tax_zone.value.value
        },
        driving_info: {
          license_number: license_number.value.value,
          renewal_from: renewal_from.value.value,
          renewal_to: renewal_to.value.value
        },
        employment_status: {
          payment: payment.value.value,
          reason_id: reason_id.value.value,
          leaving_date: leaving_date.value.value,
          note: note.value.value
        }
      };

      store.dispatch('saveEmployeeGeneralInfo', generalInfoData)
        .then((response) => {
          toast.success(response?.data?.message, { timeout: 3000 });
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || 'Failed to update general information');
        })
        .finally(() => {
          submitting.value = false;
        });
    });

    return {
      submit,
      employee_id,
      code,
      employee_type_id,
      branch_id,
      department_id,
      designation_id,
      section_id,
      status,
      phone_office,
      phone_residence,
      joining_date,
      hod_approve_employee_id,
      hr_approve_employee_id,
      employee_category,
      office_location,
      appointment_date,
      confirmation_date,
      late_count,
      bank_id,
      account_number,
      tin_number,
      tax_circle,
      tax_zone,
      license_number,
      renewal_from,
      renewal_to,
      payment,
      reason_id,
      leaving_date,
      note,
      submitting,
      formattedDate
    };
  }
};
</script>
